/**
 * Centralised runtime configuration.
 * All values are read from Vite env variables so they can be overridden
 * per-environment (dev / staging / prod) without changing source code.
 *
 * Add new variables to .env.local (local dev) and the CI/CD secrets store
 * (staging / prod). Never hard-code URLs or keys in source files.
 */

export const API_BASE =
  import.meta.env.VITE_API_BASE ||
  'https://e72r86p0bb.execute-api.us-east-1.amazonaws.com/v1/manager/smart-com'

export const GOOGLE_CLIENT_ID =
  import.meta.env.VITE_GOOGLE_CLIENT_ID || ''

export const IOS_CLIENT_ID =
  import.meta.env.VITE_IOS_CLIENT_ID ||
  '237963754768-too4fo6kt2im7umdn3g6vs4j6n65eo3q.apps.googleusercontent.com'

export const ANDROID_CLIENT_ID =
  import.meta.env.VITE_ANDROID_CLIENT_ID || ''

export const YOUTUBE_API_KEY =
  import.meta.env.VITE_YOUTUBE_API_KEY || ''
